import React from 'react'
import "./home.css"
import BigButton from '../utils/BigButton/BigButton'
import { Link } from 'react-router-dom'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'
import HomeVideo from './video/AFZ02.mp4'
import { useEffect, useState } from 'react'
import { MobileOnlyView, isMobileOnly } from 'react-device-detect';
import ModalRent from './ModalRent'
import HomeMobile from './HomeMobile'

const Home = () => {
const { selectedLanguage } = useLangContext()
const text = homeTexts[selectedLanguage];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

useEffect(()=>{
  window.scrollTo(0,0);
},[])

  return (
   <>
   
    <div className={isMobileOnly ? "display-none":'homeBackgound'}>
      <video autoPlay playsInline muted className='home-video'>
        <source src={HomeVideo} type='video/mp4' />
      </video>
      <div className='gradient'>
      <div className='hero'>
        <div className='homeTitle'>
        <h1>{text.title1}<br></br>{text.title2}</h1>
        </div>
        <div className='button-box'>
        
        <button onClick={toggleModal} className="dark-button-home"  >{text.productButton}</button>
       
        <Link to="/contacto">
        <BigButton className="dark-button-home" name={text.contactButton} />
        </Link>
        </div>
        {isModalOpen && (
          <ModalRent toggleModal={toggleModal}/>
      )}
      </div>
      </div>
    </div>
   
    <MobileOnlyView>
   <HomeMobile />
    </MobileOnlyView>
    </>
   
  )
}

export default Home
